import { render, staticRenderFns } from "./IndicesTematicos.vue?vue&type=template&id=766a7714"
import script from "./IndicesTematicos.vue?vue&type=script&lang=js"
export * from "./IndicesTematicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports